import { BodyText, LabelText } from '@policygenius/mortar';
import classnames from 'classnames';
import React from 'react';

import styles from './question-box.module.scss';
import { QuestionBoxProps } from './types';

const QuestionBox: React.FC<QuestionBoxProps> = ({
  questionText,
  answerText,
  standalone = false,
}) => (
  <div className={classnames(styles['question-box'], !standalone && styles['input-linked'])}>
    <LabelText size="large">{questionText}</LabelText>
    {answerText.map((string) => (
      <BodyText key={string}>{string}</BodyText>
    ))}
  </div>
);

export default QuestionBox;
